// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"e4a89eeb","109":"8997821b","787":"5414088a","875":"428ca922"}[chunkId] + ".chunk.js";
};